import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Parser from 'rss-parser';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
// import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import List from '@material-ui/core/List';
import Modal from '@material-ui/core/Modal';
import ErrorIcon from '@material-ui/icons/Error';
import { Grid } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGroups,
  getGroupDetail,
  getGroupAmountInfo,
  editGroupLogged,
  getGroupCampaignAmountInfo,
  getGroupGochiKidAmountInfo
} from '../../actions/Groups';
import { getDepositDetailCurrentMonthGroup } from '../../actions/Deposits';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';
import PostsTableGroup from '../organisms/PostsTableGroup';
import ShopTableGroup from '../organisms/ShopTableGroup';
import GroupPaymentInfoGroup from '../organisms/GroupPaymentInfoGroup';
import DetailPostGroupModal from '../../components/molecules/DetailPostGroupModal';
import GroupFirstLoginDialog from '../../components/molecules/GroupFirstLoginDialog';
import { getOptionCities } from '../../actions/Cities';
import PolicyFirstLoginGroupDialog from '../../components/molecules/PolicyFirstLoginGroupDialog';
import {
  GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS,
  getFirstLoginAfterReleaseShop,
  putFirstLoginAfterReleaseShop
} from '../../actions/TopPage';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  titlePaper: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  linkRight: {
    marginLeft: 'auto',
    fontSize: 14,
    fontWeight: 'bold'
  },
  rowTitle: {
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  boxGrey: {
    padding: 20,
    backgroundColor: '#FAFAFA',
    marginBottom: 20
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10
  },
  rowBox: {
    display: 'flex',
    marginLeft: '-20px',
    marginRight: '-20px'
  },
  rowColTwo: {
    width: '50%',
    paddingLeft: 10,
    paddingRight: 10
  },
  rowColTwoRight: {
    borderLeft: '1px solid #D1D1D1'
  },
  rowInCol: {
    display: 'flex'
  },
  colTwoInCol: {
    width: '50%',
    paddingLeft: 10,
    paddingRight: 10
  },
  textExplain: {
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 10,
    marginTop: 15
  },
  cardAmount: {
    borderRadius: 0
  },
  cardHeader: {
    height: 32,
    backgroundColor: '#2196F3',
    padding: '8px 15px',
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 'bold',
    whiteSpace: 'no-wrap'
  },
  cardContent: {
    padding: '10px 15px',
    paddingBottom: '10px !important'
  },
  titleAmount: {
    fontSize: 40,
    fontWeight: 'bold',
    whiteSpace: 'no-wrap'
  },
  unit: {
    fontSize: 20
  },
  modalMobile: {
    width: '60%',
    height: 'auto',
    margin: ' 0 auto'
  },
  importantItem: {
    color: '#C2000A',
    backgroundColor: '#FFD5D7',
    cursor: 'pointer'
  },
  importantItemIcon: {
    padding: '8px 0 0 16px'
  },
  dateText: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5
  },
  titleContent: {
    fontSize: 14
  },
  boxCnt: {
    padding: '0 0 40px 0'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroups,
          getGroupDetail,
          getShops,
          getAccounts,
          getGroupAmountInfo,
          getDepositDetailCurrentMonthGroup,
          getOptionCities,
          editGroupLogged,
          getGroupCampaignAmountInfo,
          getFirstLoginAfterReleaseShop,
          putFirstLoginAfterReleaseShop,
          getGroupGochiKidAmountInfo
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('rssItems', 'setRssItems', []),
  withState('rssItemsFull', 'setRssItemsFull', []),
  withState('rssImportantItems', 'setRssImportantItems', []),
  withState('openFirstLoginDialog', 'updateOpenFirstLoginDialog', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', false),
  withState('loading', 'updateLoading', false),
  withState('groupAmount', 'setGroupAmount', {}),
  withState('groupId', 'setGroupId', 0),
  withState('shops', 'setShops', []),
  withState('openDetailPost', 'setDetailPost', false),
  withState('content', 'setContent', ''),
  withState(
    'openPolicyFirstLoginModal',
    'updateOpenPolicyFirstLoginModal',
    false
  ),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleGetShops: props => () => {
      props.actions
        .getShops({
          page: 1,
          limit: 5
        })
        .then(shopData => {
          if (shopData.error === true && shopData.payload.status === 403) {
            sendLogin(props);
          }
          if (shopData.type === 'GET_SHOPS_SUCCESS') {
            // this.props.updateOpenTable(true);
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.updateOpenProgress(true);
      this.props.updateLoading(true);

      // Get list city first to prepare for action edit
      this.props.actions.getOptionCities();
      if (
        (this.props.account.groupType === 'CAMPAIGN' ||
          this.props.account.groupType === 'OTHERS') &&
        this.props.account.fukuokaFlag !== 1
      ) {
        this.props.actions.getGroupCampaignAmountInfo().then(data => {
          this.props.checkSession(data);
          if (data.type === 'GET_GROUP_AMOUNT_SUCCESS') {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
            this.props.setGroupAmount(data.payload);
          } else {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
          }
        });
      } else if (
        this.props.account.groupType === 'GOCHI_KID' &&
        this.props.account.fukuokaFlag !== 1
      ) {
        this.props.actions.getGroupGochiKidAmountInfo().then(data => {
          this.props.checkSession(data);
          if (data.type === 'GET_GROUP_AMOUNT_SUCCESS') {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
            this.props.setGroupAmount(data.payload);
          } else {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
          }
        });
      } else {
        this.props.actions.getGroupAmountInfo().then(data => {
          this.props.checkSession(data);
          if (data.type === 'GET_GROUP_AMOUNT_SUCCESS') {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
            this.props.setGroupAmount(data.payload);
          } else {
            this.props.updateOpenProgress(false);
            this.props.updateLoading(false);
          }
        });
      }

      const parser = new Parser();

      // get noti rss
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/42755547-51ae-4b47-af16-f50b58d106f2.rss`,
        (err, feed) => {
          if (err) throw err;
          const size = 3;
          const start = 0;
          this.props.setRssItemsFull(feed.items);
          const rssItemsFullArray = feed.items;
          const items = rssItemsFullArray.slice(
            parseInt(start, 10),
            parseInt(size, 10)
          );
          this.props.updateOpenTable(true);
          this.props.setRssItems(items);
        }
      );

      // get important
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/7872cf17-bbf8-402a-bd7b-727c8b5bb32e.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssImportantItems(feed.items);
        }
      );

      // this.props.actions
      //   .getShops({
      //     page: 1,
      //     limit: 5
      //   })
      //   .then(shopData => {
      //     this.props.checkSession(shopData);
      //     if (shopData.type === 'GET_SHOPS_SUCCESS') {
      //       // this.props.updateOpenTable(true);
      //     }
      //     this.props.updateOpenProgress(false);
      //     this.props.updateLoading(false);
      //   });

      this.props.handleGetShops();

      const searchKey = {
        page: 1,
        limit: 5
      };

      this.props.actions
        .getDepositDetailCurrentMonthGroup(searchKey)
        .then(data => {
          this.props.checkSession(data);
          this.props.setShops(data.payload.list);
          // props.setTotalCount(data.payload.count);
          // props.setLimit(data.payload.limit);
          this.props.updateOpenProgress(false);
          this.props.setResultMessage('');
          this.props.updateLoading(false);
          this.props.updateOpenTable(true);
        })
        .catch(() => {
          this.props.updateOpenProgress(false);
          this.props.setResultMessage('');
          this.props.updateLoading(false);
        });

      // Show dialog when first time group login to home page
      if (
        this.props.account &&
        this.props.account.groupAccountStatus &&
        !this.props.account.groupAccountStatus.flagLogged
      ) {
        this.props.updateOpenFirstLoginDialog(true);
        this.props.actions
          .editGroupLogged(this.props.account.groupId, {
            flagLogged: 1
          })
          .then(() => {
            this.props.actions.getAccounts({ cognitoUserId: '' });
          });
      }

      this.props.actions.getFirstLoginAfterReleaseShop().then(data => {
        if (data.type === GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS) {
          if (data.payload.firstLogin !== 0) {
            this.props.updateOpenPolicyFirstLoginModal(true);
          }
        } else {
          this.props.updateOpenPolicyFirstLoginModal(true);
        }
      });
    }
  })
);

const dateFormat = timeStr => {
  if (!timeStr) {
    return null;
  }
  const date = new Date(timeStr);
  const day = date.getDate();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  const year = date.getFullYear();
  return `${year}/${month}/${day}`;
};

const getDayOfWeek = date => {
  const dayOfWeek = new Date(date).getDay();
  return !dayOfWeek
    ? null
    : ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek];
};

const HomeGroup = enhance(
  ({
    actions,
    checkSession,
    handleRedirect,
    handleGetShops,
    classes,
    account,
    openFirstLoginDialog,
    updateOpenFirstLoginDialog,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    groupAmount,
    rssItems,
    rssImportantItems,
    resultMessage,
    setResultMessage,
    groupId,
    setGroupId,
    shops,
    openTable,
    content,
    setContent,
    setDetailPost,
    openDetailPost,
    openPolicyFirstLoginModal,
    updateOpenPolicyFirstLoginModal
  }) => {
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const groupDisplayLimitType =
      typeof account !== 'undefined' &&
      account.role === 'GROUP' &&
      (account.groupType === 'CAMPAIGN' ||
        account.groupType === 'OTHERS' ||
        account.groupType === 'GOCHI_KID');

    const openDetailSummary = () => {
      handleRedirect('summary_report_group');
    };

    const openNotificationsGroup = () => {
      handleRedirect('notifications_group');
    };

    const openDetailShopGroup = () => {
      handleRedirect('shops_group');
    };

    const openDeposit = () => {
      handleRedirect('deposit_group');
    };

    const currencyFormat = num => {
      if (!num) {
        return 0;
      }
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      resultMessage,
      setResultMessage
    };

    useEffect(() => {
      actions.getGroupDetail(account.groupId).then(groupData => {
        checkSession(groupData);
        if (groupData.type === 'GET_GROUP_DETAIL_SUCCESS') {
          //
        }
        updateOpenProgress(false);
        updateLoading(false);
      });
    }, []);

    const detailOpenAction = params => {
      setContent(params);
      setDetailPost(true);
    };

    const importantRssParams = () => {
      const params = {
        title: rssImportantItems[0].title,
        content: rssImportantItems[0].content,
        pubDate: `${dateFormat(rssImportantItems[0].pubDate)} (${getDayOfWeek(
          rssImportantItems[0].pubDate
        )})`
      };
      return params;
    };

    const handleClickAccessPolicy = () => {
      updateOpenPolicyFirstLoginModal(false);
      actions
        .putFirstLoginAfterReleaseShop({ firstLogin: 0 })
        .then(data => checkSession(data));
    };

    const groupDisplayLimit = account.groupDisplayLimit === 1;

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="ごちめしグループ 株式会社" />

        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            {account.groupName}
          </Typography>
          {rssImportantItems && rssImportantItems.length > 0 && (
            <Box className={classes.boxCnt}>
              <Paper className={classes.mainPaperWhite} elevation={1}>
                <List
                  component="nav"
                  className={(classes.listNotis, classes.importantItem)}
                  aria-label="contacts"
                >
                  <Grid
                    container
                    className={classes.importantItem}
                    onClick={() => detailOpenAction(importantRssParams())}
                  >
                    <Grid item xs={0.5} className={classes.importantItemIcon}>
                      <ErrorIcon />
                    </Grid>
                    <Grid item xs={11.5}>
                      <ListItem>
                        <div>
                          <div className={classes.dateText}>重要なお知らせ</div>
                          <div className={classes.titleContent}>
                            {rssImportantItems[0].title}
                          </div>
                        </div>
                      </ListItem>
                    </Grid>
                  </Grid>
                </List>
              </Paper>
            </Box>
          )}

          <Paper className={classes.paperWhite}>
            <div className={classes.rowTitle}>
              <Typography
                variant="h6"
                color="textPrimary"
                className={classes.titlePaper}
              >
                グループ全体
              </Typography>

              <Button
                onClick={groupDisplayLimit ? openDetailSummary : openDeposit}
                color="primary"
                className={classes.linkRight}
              >
                全て見る
                <ChevronRightIcon />
              </Button>
            </div>

            <div className={classes.boxGrey}>
              <div className={classes.subTitle}>
                {/* {groupAmount && groupAmount.nextMonthStr} đây là yêu cầu của qc nhungdt muon lay month tu client */}
                {`${new Date().getMonth() + 1}`}
                月のサマリーレポート
              </div>

              <div className={classes.rowBox}>
                <div className={classes.rowColTwo}>
                  <div className={classes.rowInCol}>
                    {!isFukuoka && (
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            グループ全体ごち購入額
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmount.gochiBuyGroupAmount
                                ? groupAmount.gochiBuyGroupAmount.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                    <div className={classes.colTwoInCol}>
                      <Card className={classes.cardAmount}>
                        <div className={classes.cardHeader}>
                          {isFukuoka
                            ? 'グループ全体利用額'
                            : 'グループ全体ごち利用額'}
                        </div>
                        <CardContent className={classes.cardContent}>
                          <Typography
                            variant="h6"
                            color="textPrimary"
                            className={classes.titleAmount}
                          >
                            {groupAmount.gochiUsedGroupAmount
                              ? groupAmount.gochiUsedGroupAmount.toLocaleString()
                              : 0}
                            <span className={classes.unit}>円</span>
                          </Typography>
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </div>
                {!groupDisplayLimit && (
                  <div
                    className={`${classes.rowColTwo} ${classes.rowColTwoRight}`}
                  >
                    <div className={classes.rowInCol}>
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            {groupAmount && groupAmount.currentMonthStr}
                            {isFukuoka ? '月の精算金額(※1)' : '月の入金金額'}
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmount.depositAmountBeforeMonth
                                ? groupAmount.depositAmountBeforeMonth.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            {isFukuoka
                              ? `現時点での${groupAmount &&
                                  groupAmount.nextMonthStr}月精算予定金額(※2)`
                              : '現在のお支払い残額'}
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {// eslint-disable-next-line no-nested-ternary
                              isFukuoka
                                ? groupAmount.depositAmountCurrentMonth
                                  ? groupAmount.depositAmountCurrentMonth.toLocaleString()
                                  : 0
                                : groupAmount.paymentBalance
                                ? groupAmount.paymentBalance.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    </div>

                    <div className={classes.textExplain}>
                      {isFukuoka && (
                        <>
                          ※1
                          毎月9営業日までは前月末の振込金額を表示します。10営業日からは今月末の振込予定金額を表示します。
                          <br />
                          ※2
                          毎月9営業日までは今月末の振込予定金額を表示します。10営業日からは翌月末の振込予定金額を表示します。
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {!groupDisplayLimit && (
              <div className={classes.rowTitle}>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  className={classes.titlePaper}
                >
                  {isFukuoka ? '教室別精算情報' : 'グループ店舗別一覧'}
                </Typography>

                <Button
                  onClick={openDetailSummary}
                  color="primary"
                  className={classes.linkRight}
                >
                  全て見る
                  <ChevronRightIcon />
                </Button>
              </div>
            )}

            {!groupDisplayLimit && (
              <GroupPaymentInfoGroup
                currencyFormat={currencyFormat}
                shops={shops}
                openTable={openTable}
                fromTopPageGroup
                isFukuoka={isFukuoka}
              />
            )}
          </Paper>

          {!isFukuoka && (
            <Paper className={classes.paperWhite}>
              <div className={classes.rowTitle}>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  className={classes.titlePaper}
                >
                  運営からのお知らせ
                </Typography>

                <Button
                  onClick={openNotificationsGroup}
                  color="primary"
                  className={classes.linkRight}
                >
                  全て見る
                  <ChevronRightIcon />
                </Button>
              </div>
              {rssImportantItems && rssImportantItems.length > 0 && (
                <Box>
                  <Paper className={classes.mainPaperWhite} elevation={1}>
                    <List
                      component="nav"
                      className={(classes.listNotis, classes.importantItem)}
                      aria-label="contacts"
                    >
                      <Grid
                        container
                        className={classes.importantItem}
                        onClick={() => detailOpenAction(importantRssParams())}
                      >
                        <Grid
                          item
                          xs={0.5}
                          className={classes.importantItemIcon}
                        >
                          <ErrorIcon />
                        </Grid>
                        <Grid item xs={11.5}>
                          <ListItem>
                            <div>
                              <div className={classes.dateText}>
                                重要なお知らせ
                              </div>
                              <div className={classes.titleContent}>
                                {rssImportantItems[0].title}
                              </div>
                            </div>
                          </ListItem>
                        </Grid>
                      </Grid>
                    </List>
                  </Paper>
                </Box>
              )}

              <PostsTableGroup rssItems={rssItems} />
            </Paper>
          )}

          <Paper className={classes.paperWhite}>
            <div className={classes.rowTitle}>
              <Typography
                variant="h6"
                color="textPrimary"
                className={classes.titlePaper}
              >
                {isFukuoka ? 'グループ教室一覧' : 'グループ店舗情報'}
              </Typography>

              <Button
                onClick={openDetailShopGroup}
                color="primary"
                className={classes.linkRight}
              >
                全て見る
                <ChevronRightIcon />
              </Button>
            </div>

            <ShopTableGroup
              page={1}
              limit={5}
              progress={progress}
              setGroupId={setGroupId}
              groupId={groupId}
              fromTopPageGroup
              handleSearch={handleGetShops}
              isFukuoka={isFukuoka}
              groupDisplayLimit={groupDisplayLimitType}
              educateSystem={educateSystem}
            />
          </Paper>

          <div className={classes.bottomButtonDiv} />
        </main>
        <Modal
          open={openDetailPost}
          onClose={() => {
            setDetailPost(false);
          }}
          className={classes.modalMobile}
        >
          <DetailPostGroupModal
            setDetailPost={setDetailPost}
            params={content}
          />
        </Modal>
        <ProgressDialog openProgress={openProgress} loading={loading} />

        <GroupFirstLoginDialog
          openProgress={openFirstLoginDialog}
          progressOkAction={() => {
            updateOpenFirstLoginDialog(false);
          }}
          isFukuoka={isFukuoka}
        />

        {!isFukuoka && (
          <PolicyFirstLoginGroupDialog
            show={openPolicyFirstLoginModal}
            okAction={handleClickAccessPolicy}
          />
        )}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(HomeGroup));
